import type { CSSProperties } from 'react';

/** Shimmer block (gradient and 1.4s sweep in MediaManagement.css). */
export function Bone({ w, h = 14, r = 6, style }: { w: number | string; h?: number; r?: number; style?: CSSProperties }) {
  return <span className="mm-shimmer" style={{ width: w, height: h, borderRadius: r, ...style }} aria-hidden="true" />;
}

/** Item Media: filter tabs + search and category toolbar while the page loads. */
export function ItemToolbarShimmer() {
  return (
    <div aria-hidden="true">
      <div className="mm-shimmer-row" style={{ gap: 8, marginBottom: 14 }}>
        <Bone w={96} h={32} r={8} />
        <Bone w={150} h={32} r={8} />
        <Bone w={160} h={32} r={8} />
      </div>
      <div className="mm-shimmer-row" style={{ gap: 12, marginBottom: 16 }}>
        <Bone w={260} h={36} r={18} />
        <Bone w={240} h={36} r={8} />
        <span style={{ flex: 1 }} />
        <Bone w={110} h={32} r={8} />
      </div>
    </div>
  );
}

function ItemRowShimmer() {
  return (
    <div className="mm-grid-row mm-shimmer-item-row">
      <Bone w={32} h={32} r={8} />
      <Bone w="55%" h={14} />
      <Bone w={64} h={20} r={10} />
      <span className="mm-hide-sm"><Bone w={64} h={20} r={10} /></span>
      <Bone w={40} h={14} />
      <span className="mm-hide-sm"><Bone w={80} h={12} /></span>
      <span className="mm-hide-sm"><Bone w={20} h={20} r={10} /></span>
    </div>
  );
}

/** Item Media: category cards with item rows, like the Product Catalog items list. */
export function ItemListShimmer() {
  return (
    <div className="mm-cat-list" aria-busy="true" aria-label="Loading items">
      {[4, 3, 2].map((rows, card) => (
        <div key={card} className="mm-cat-card">
          <div className="mm-shimmer-row" style={{ gap: 12, padding: '14px 16px' }}>
            <Bone w={20} h={20} r={4} />
            <Bone w="30%" h={16} />
            <Bone w={56} h={20} r={10} />
          </div>
          <div className="mm-shimmer-rows">
            {Array.from({ length: rows }).map((_, i) => <ItemRowShimmer key={i} />)}
          </div>
        </div>
      ))}
    </div>
  );
}

/** Location Media: the tile grid while it loads. */
export function LocationGridShimmer({ tiles = 7 }: { tiles?: number }) {
  return (
    <div className="mm-form-card mm-full" aria-busy="true" aria-label="Loading media">
      <div className="mm-shimmer-row" style={{ gap: 8, marginBottom: 12 }}>
        <Bone w={48} h={14} />
        <Bone w={96} h={20} r={10} />
      </div>
      <div className="mm-tile-grid mm-wide">
        {Array.from({ length: tiles }).map((_, i) => (
          <span key={i} className="mm-shimmer mm-shimmer-tile" aria-hidden="true" />
        ))}
      </div>
      <Bone w="40%" h={12} style={{ marginTop: 12 }} />
    </div>
  );
}
